export default __webpack_public_path__ + "static/media/success-checkmark.1dd3e7a8.svg";